import React from 'react';
import {inject, observer} from 'mobx-react';

import E9TopLogo from './E9TopLogo';
import E9Home from './E9Home';
import E9TopMenu from './E9TopMenu';
import E9FreqUseMenu from './E9FreqUseMenu';
import E9QuickSearch from './E9QuickSearch';
import E9HeaderRight from './E9HeaderRight';

@inject('portalThemeStore')
@observer
class E9Header extends React.Component {
    render() {
        const {portalThemeStore} = this.props;
        const {themeInfo} = portalThemeStore;
        const {themeLogoWidth, themeData = {}} = themeInfo;
        const {styleConfig = {}} = themeData;
        const {header = {}} = styleConfig;
        const fontSize = parseInt(header.fontSize || '12px');
        const logoWidth = themeLogoWidth === '' ? 197 : parseInt(themeLogoWidth);

        return (
            <div className={`e9header-container wea-f${fontSize}`}>
                <div className="e9header-left" style={{width: logoWidth}}>
                    <E9TopLogo {...this.props} />
                </div>
                <div className="e9header-right" style={{marginLeft: logoWidth}}>
                    <div className="e9header-right-menu">
                        <E9Home {...this.props} />
                        <E9TopMenu {...this.props} />
                        <E9FreqUseMenu {...this.props} />
                        <E9QuickSearch {...this.props} />
                    </div>
                    <E9HeaderRight {...this.props} />
                </div>
            </div>
        );
    }
}

export default E9Header;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/E9Header.js